module.exports = __webpack_public_path__ + "img/STALE.58095283.svg";